export default __webpack_public_path__ + "static/statutory_work_filling-8b9d1a9e71d3a8e266740c9763a64cba.png";